var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNudoMarkLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    width: 400,
    height: 400,
    role: "img",
    "aria-label": "Nudo Lab",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FBF6EF",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 47 200 L 81 200              C 81 140.5 140.5 140.5 200 200              C 259.5 140.5 319 140.5 319 200              C 319 259.5 259.5 259.5 200 200              C 140.5 259.5 81 259.5 81 200"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 319,
    y1: 200,
    x2: 353,
    y2: 200
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNudoMarkLight);
export default __webpack_public_path__ + "static/media/nudo-mark-light.48600eb4a0d357f4729db7ab2609b712.svg";
export { ForwardRef as ReactComponent };